<template>
  <div class="text-white px-4 mb-5">
    <main>
      <section class="pt-5 ps-4">
        <div class="font-bold p-5 mb-3 text-4xl">Games</div>
        <p class="w-full md:w-100 px-5 pl-6 pb-5 text-md">
          MetX Games is where you can enjoy playing and testing blockchain games in the {{ label }} environment either on MetX Games or on your smartphone. You can then give feedback to the game developer of a game you played.
        </p>
      </section>
      <section class="px-4" v-if="isValid">
        <div class="my-3 pl-2">New Invitations</div>
        <div class="grid xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 mb-4">
          <router-link :to="{ name: 'viewGamesDetails', params: { gameId: gameId }}" class="hover:opacity-80 m-3 transition-all duration-200 drop-shadow-xl">
            <div>
              <div class="card-img-top" v-if="headerImage != 'none'" :style="'background: url(' + headerImage + '); background-repeat: no-repeat; background-size: cover;'" >
              </div>
              <div class="card-img-top" v-else style="display:block; overflow: hidden;">
                <img :src="require(`@/assets/images/default-cover.png`)">
              </div>
              <div class="bg-black-body p-2 truncate text-gray-text">
                <h6 class="text-sm text-white font-bold mb-0 truncate">{{ title }}</h6>
                <small class="text-sm text-gray-text truncate" v-html="about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)"></small>
              </div>
            </div>
          </router-link>
        </div>
      </section>
    </main>

    <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <!--
        Background backdrop, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <div class="fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity" v-if="showModal"></div>
      </transition>
      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <div class="fixed z-10 inset-0 overflow-y-auto" v-if="showModal">
          <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
            <div class="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full" id="popupDashboard">
              <div class="modal-dialog modal-dialog-centered" v-if="isValid">
                <div class="modal-content bg-black-body text-white">
                  <div v-if="headerImage != 'none'" :style="'background-image: url(' + headerImage + '); background-repeat: no-repeat;'" class="modal-background"></div>
                  <div v-else class="absolute w-full h-full overflow-hidden block">
                    <img :src="require(`@/assets/images/default-cover.png`)">
                  </div>
                  <div class="overlay z-30" :class="headerImage == 'none'?'light':''"></div>
                  <div class="modal-body p-10 lg:px-20 text-center z-50 relative">
                    <h2 class="text-red-primary m-0 mb-3">Welcome, {{ gamerId }}!</h2>
                    <p class="text-white mb-5">You are invited to test the game "{{ title }}".</p>
                    <router-link :to="{ name: 'viewGamesDetails', params: { gameId: gameId }}" class="btn-primary inline-block mb-3 text-sm my-5">View Game</router-link>
                    <br />
                    <a href="#" class="my-5 text-gray-500 text-sm text-md underline inline-block hover:text-gray-300 transition-all duration-200" @click="showModal = !showModal">I'll do it later</a>
                  </div>
                </div>
              </div>
              <div class="modal-dialog modal-dialog-centered" v-else>
                <div class="modal-content bg-black-body text-white">
                  <div class="block overflow-hidden w-full h-full absolute">
                    <img :src="require(`@/assets/images/default-cover.png`)">
                  </div>
                  <div class="overlay light"></div>
                  <div class="modal-body p-16 text-center z-50 relative">
                    <h2 class="text-red-primary m-0 mb-3">Welcome, {{ gamerId }}!</h2>
                    <p class="text-white mb-5">You have not received invitation to play this game</p>
                    <br />
                    <a href="#" class="btn-primary mb-3" @click="showModal = !showModal">Noted</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import { defineComponent, ref, computed } from "vue";
import { InviteUtils } from '@/utils/InviteUtils';
import { GameUtils } from '@/utils/GameUtils';
import { useStore } from 'vuex';

export default defineComponent({

  name: "viewInvite",
  props: {
    gameId: String
  },
  setup(props){
    const store = useStore();
    const showModal = ref(false);

    setTimeout(() => {
      showModal.value = true;
    }, 1500);

    const userObj = store.getters['auth/user'];
    const gamerId = ref(userObj.username);
    const title = ref('');
    const about = ref('');
    const headerImage = ref('');
    const isValid = ref(false);
    const label = computed(() => {
      return store.getters['config/configLabel'];
    })

    const isGameInvitationValid = ref(false);

    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });

    // check if the invitation is valid
    (async() => {
      const gameInvitation = new InviteUtils();
      isValid.value = await gameInvitation.validateGameInvitation(props.gameId);
      let gameDetails = {}
      if(isValid.value){
        isGameInvitationValid.value = true;
        // valid invitation
        // fetch publishGame API
        gameDetails = await GameUtils.fetchPublishedGame(props.gameId);
        title.value = gameDetails.viewModel.game.title;
        about.value = gameDetails.viewModel.details.about.about;
        if(gameDetails.viewModel.details.gallery.headerImage){
          headerImage.value = assetURL.value + `blob/games/${props.gameId}/gallery/${gameDetails.viewModel.details.gallery.headerImage}`;
        }else{
          headerImage.value = 'none';
        }
      }
    })()
    return{
      gamerId,
      isValid,
      title,
      about,
      headerImage,
      label,
      assetURL,
      showModal,
    }
  }
});
</script>

<style lang="scss" scoped>

.card-img-top {
  height: 250px !important;
}

#popupDashboard{
  .modal-content > .modal-background{
    border:transparent !important;
    @apply absolute w-full h-full bg-cover z-20;
  }
   .overlay{
    height: 100%;
    background: #000000;
    opacity: 0.85;
    width: 100%;
    padding: 0px;
    position: absolute;
  }
  .overlay.light{
    opacity: 0.2;
  }
}
</style>
